<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Auteurs
        </h2>
        <div class="actions">
            <button (click)="openModal({})" class="btn btn-primary">
                Toevoegen
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/authors'" [columnMapping]="[
    { key: 'name', label: 'Naam' },
    { key: 'type', label: 'Type' }
  ]" [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
    </app-table-guru>
</div>